// Pure helpers for the monthly recovery report panels, kept out of the tab so jest can load them.

export const SKIP_REASON_LABELS = {
  BillCopyIsNotAvailable: 'No bill copy available',
  NoActiveResidents: 'No active residents',
  OffCycle: 'Off-cycle (bi-monthly or quarterly)',
  Other: 'Other',
  NotRecorded: 'Reason not recorded'
};
export const skipReasonLabel = reason => {
  var _SKIP_REASON_LABELS$r;
  return (_SKIP_REASON_LABELS$r = SKIP_REASON_LABELS[reason]) !== null && _SKIP_REASON_LABELS$r !== void 0 ? _SKIP_REASON_LABELS$r : reason;
};

/** Who an on-demand report goes to. The API resolves the addresses, so a report never leaves the company. */
export const AUDIENCES = [{
  value: 'Me',
  label: 'Me'
}, {
  value: 'AccountHolders',
  label: 'Account Holders'
}];
/**
 * Same rule as saas-property-service StripeSubscriptionClient.ToPlan. `subscription/company` returns Active
 * subscriptions only, so every item counts. Null when there is no item, so a company without a subscription is
 * never labelled Self-Service and offered an upgrade.
 */
export const planFrom = subscriptions => {
  const items = (subscriptions !== null && subscriptions !== void 0 ? subscriptions : []).flatMap(s => {
    var _s$items;
    return (_s$items = s.items) !== null && _s$items !== void 0 ? _s$items : [];
  });
  if (!items.length) return null;
  return {
    isBillingAutomation: items.some(i => {
      var _i$productName;
      return /bill automation/i.test((_i$productName = i.productName) !== null && _i$productName !== void 0 ? _i$productName : '');
    }),
    monthlyTotal: items.reduce((sum, i) => sum + (Number(i.currentTotal) || 0), 0)
  };
};